import React from 'react'
import Heading from '../Heading';
import { motion } from "framer-motion";
import { Community_connects } from '../../Data/E_Offer';
const Connects = () => {
      const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
  return (
   <motion.section 
            className="main-lwbl bg-[#F9FAFB] pt-16 pb-16 px-[0.5rem] overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
           <Heading subHeading={"Multiple interaction channels designed to bring artists closer"}
             heading={"Where the Community Connects and Collaborates"}
             detail={"From open conversations to curated learning spaces, our community features a variety of connection points. Each space supports unique goals—seeking advice, celebrating achievements, discussing challenges, or simply finding inspiration."}
           />
            
            <div className='flex flex-wrap justify-center items-center gap-[10px] mt-[3rem]'>
               {Community_connects.map((data,index)=>(
                   <div key={index} className='text-center border-[2px] flex flex-col gap-[1rem] p-[1rem] items-center justify-center border border-black rounded-[30px] w-[290px] h-[260px]'>
                         <h2 className='font-cinzel text-[24px] '>{data.title}</h2>
                          <p  className='font-outfit text-[18px]'>
            {data.description}
         </p>
                   </div>
               ))}

            </div>

           </motion.section>
  )
}

export default Connects
